import {Component, Inject} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {HttpErrorResponse} from '@angular/common/http';
import {finalize} from 'rxjs/operators';
import {UserService} from '../../../services/user/user.service';

export interface DeleteAccountDialogData {
  userId: number;
}

/**
 * deletes the own account after the user entered their email and password again.
 * Closes with `true` once the account is deleted.
 */
@Component({
  selector: 'app-delete-account-dialog',
  templateUrl: './delete-account-dialog.component.html',
  styleUrls: ['./delete-account-dialog.component.scss'],
  standalone: false
})
export class DeleteAccountDialogComponent {

  form = new FormGroup({
    email: new FormControl('', [Validators.required, Validators.email]),
    password: new FormControl('', Validators.required)
  });
  hidePassword = true;
  deleting = false;
  errorMessage: string;

  constructor(@Inject(MAT_DIALOG_DATA) public data: DeleteAccountDialogData,
              private dialogRef: MatDialogRef<DeleteAccountDialogComponent, boolean>,
              private userService: UserService) {
  }

  delete(): void {
    // pasted addresses often contain surrounding spaces, which the email validator rejects
    const emailCtrl = this.form.controls.email;
    if (emailCtrl.value !== emailCtrl.value?.trim()) {
      emailCtrl.setValue(emailCtrl.value.trim());
    }
    if (this.form.invalid || this.deleting) {
      this.form.markAllAsTouched();
      return;
    }
    this.deleting = true;
    this.errorMessage = null;
    const {email, password} = this.form.value;
    this.userService.deleteOwnAccount(this.data.userId, email, password)
      .pipe(finalize(() => this.deleting = false))
      .subscribe({
        next: () => this.dialogRef.close(true),
        error: (error: HttpErrorResponse) => {
          this.errorMessage = error.status === 400
            ? 'E-Mail-Adresse oder Passwort ist nicht korrekt.'
            : 'Der Account konnte nicht gelöscht werden. Bitte versuchen Sie es später erneut.';
          this.form.controls.password.reset();
        }
      });
  }
}
